import { inspectionsConstants } from '../constants'

const initialState = {
  uploading: false,
  list: null,
  loading: false,
  lot: ''
}

export default function inspections (state = initialState, action) {
  switch (action.type) {
    case inspectionsConstants.INSPECTIONS_UPLOADING:
      return { ...state, uploading: true }
    case inspectionsConstants.INSPECTIONS_UPLOADING_SUCCESS:
      return { ...state, uploading: false }
    case inspectionsConstants.LOADING_INSPECTIONS:
      return { ...state, loading: true, lot: action.payload, list: null, error: null }
    case inspectionsConstants.LOADING_INSPECTIONS_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null }
    case inspectionsConstants.LOADING_INSPECTIONS_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}
